import { FC, PropsWithChildren } from 'react'

import classnames from 'classnames'

import { DropdownPosition, DropdownSide } from './types'
import DropdownButton from './dropdownButton'
import DropdownMenuDivider from './dropdownMenuDivider'
import DropdownMenuHeader from './dropdownMenuHeader'
import DropdownMenuItem from './dropdownMenuItem'
import '@hotmart/cosmos/dist/dropdown'
import './dropdown.scss'

export interface Props {
  className?: string,
  position?: DropdownPosition,
  side?: DropdownSide,
  slot?: string
}

interface WithDropdownElements {
  Button: typeof DropdownButton,
  Divider: typeof DropdownMenuDivider,
  Header: typeof DropdownMenuHeader,
  Item: typeof DropdownMenuItem
}

const Dropdown: FC<PropsWithChildren<Props>> & WithDropdownElements = ({
  children,
  className,
  position = DropdownPosition.BOTTOM,
  side = DropdownSide.LEFT,
  slot
}) => {
  return (
    <hot-dropdown
      class={classnames(className, position, 'dropdown')}
      menu-side={side}
      slot={slot}>
      {children}
    </hot-dropdown>
  )
}

Dropdown.Button = DropdownButton
Dropdown.Divider = DropdownMenuDivider
Dropdown.Header = DropdownMenuHeader
Dropdown.Item = DropdownMenuItem

export default Dropdown
